import { CircularProgress, Grid2, SpeedDial, SpeedDialAction, SpeedDialIcon, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import _ from 'lodash';
import { useContext } from "react";
import { DialogsContext, SessionDataContext } from '../contexts';
import StudentCard from "./student.card";
import { studentApi } from "./student.queries";
import LoadingIndicator from "../common/loading.indicator";

export default function StudentList(props) {
	const useGetAll = studentApi.useGetAll();
	let students = useGetAll?.data;

	const { dialogs } = useContext(DialogsContext);
	const sessionData = useContext(SessionDataContext);	

	if (useGetAll?.isPending) {
		return <LoadingIndicator />;
	}

	students = _.orderBy(students, 'name');

	return (
		<Box sx={{ p: 2 }}>
			<Grid2 container spacing={4}>
				{students?.length > 0 && students.map((student) => (
					<Grid2 size={{ xs: 12, sm: 6, lg: 4, xl: 3 }} key={student.id}>
						<StudentCard student={student} />
					</Grid2>
				))}
			</Grid2>

			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>New Student</Typography>} onClick={() => dialogs.open('student', {})} />
			</SpeedDial>
		</Box >
	);
}
